// eslint-disable-next-line regexp/no-unused-capturing-group, prefer-named-capture-group, sonarjs/slow-regex -- It's ok
export const removeTags = (text: string) => text.replaceAll(/(<([^>]+)>)/g, "");
